// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TeamMembersTileInternalUsersQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type TeamMembersTileInternalUsersQuery = { __typename?: 'Query', project: { __typename?: 'StandaloneProject', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } | { __typename?: 'Region', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } | { __typename?: 'Market', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } | { __typename?: 'Community', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } | { __typename?: 'Subdivision', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } | { __typename?: 'Lot', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } | { __typename?: 'Structure', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } | { __typename?: 'Unit', id: string, teamMembers: Array<{ __typename?: 'ProjectTeamMember', role: { __typename?: 'ProjectRoleDetail', code: Types.ProjectRole, name: string, sortOrder: number }, user?: { __typename?: 'InternalUser', id: string, name: string, email: string, avatar: string } | null | undefined }> } };

export type TeamMembersTileTradePartnersQueryVariables = Types.Exact<{
  filter: Types.TradePartnerFilter;
  projectId: Types.Scalars['ID']['input'];
}>;


export type TeamMembersTileTradePartnersQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, averageScore: number, reviewCount: number, primaryForProject?: { __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined, mobilePhone?: string | null | undefined, officePhone?: string | null | undefined, title?: string | null | undefined } | null | undefined, tradeCategories: Array<{ __typename?: 'TradeCategory', id: string, name: string }> }> };


export const TeamMembersTileInternalUsersDocument = gql`
    query TeamMembersTileInternalUsers($projectId: ID!) {
  project(id: $projectId) {
    id
    teamMembers {
      role {
        code
        name
        sortOrder
      }
      user {
        id
        name
        email
        avatar
      }
    }
  }
}
    `;

/**
 * __useTeamMembersTileInternalUsersQuery__
 *
 * To run a query within a React component, call `useTeamMembersTileInternalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersTileInternalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersTileInternalUsersQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTeamMembersTileInternalUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMembersTileInternalUsersQuery, TeamMembersTileInternalUsersQueryVariables> & ({ variables: TeamMembersTileInternalUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMembersTileInternalUsersQuery, TeamMembersTileInternalUsersQueryVariables>(TeamMembersTileInternalUsersDocument, options);
      }
export function useTeamMembersTileInternalUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMembersTileInternalUsersQuery, TeamMembersTileInternalUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMembersTileInternalUsersQuery, TeamMembersTileInternalUsersQueryVariables>(TeamMembersTileInternalUsersDocument, options);
        }
export function useTeamMembersTileInternalUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersTileInternalUsersQuery, TeamMembersTileInternalUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMembersTileInternalUsersQuery, TeamMembersTileInternalUsersQueryVariables>(TeamMembersTileInternalUsersDocument, options);
        }
export type TeamMembersTileInternalUsersQueryHookResult = ReturnType<typeof useTeamMembersTileInternalUsersQuery>;
export type TeamMembersTileInternalUsersLazyQueryHookResult = ReturnType<typeof useTeamMembersTileInternalUsersLazyQuery>;
export type TeamMembersTileInternalUsersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersTileInternalUsersSuspenseQuery>;
export type TeamMembersTileInternalUsersQueryResult = Apollo.QueryResult<TeamMembersTileInternalUsersQuery, TeamMembersTileInternalUsersQueryVariables>;
export const TeamMembersTileTradePartnersDocument = gql`
    query TeamMembersTileTradePartners($filter: TradePartnerFilter!, $projectId: ID!) {
  tradePartners(filter: $filter) {
    id
    name
    averageScore
    reviewCount
    primaryForProject(projectId: $projectId) {
      id
      name
      email
      mobilePhone
      officePhone
      title
    }
    tradeCategories {
      id
      name
    }
  }
}
    `;

/**
 * __useTeamMembersTileTradePartnersQuery__
 *
 * To run a query within a React component, call `useTeamMembersTileTradePartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersTileTradePartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersTileTradePartnersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useTeamMembersTileTradePartnersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TeamMembersTileTradePartnersQuery, TeamMembersTileTradePartnersQueryVariables> & ({ variables: TeamMembersTileTradePartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TeamMembersTileTradePartnersQuery, TeamMembersTileTradePartnersQueryVariables>(TeamMembersTileTradePartnersDocument, options);
      }
export function useTeamMembersTileTradePartnersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TeamMembersTileTradePartnersQuery, TeamMembersTileTradePartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TeamMembersTileTradePartnersQuery, TeamMembersTileTradePartnersQueryVariables>(TeamMembersTileTradePartnersDocument, options);
        }
export function useTeamMembersTileTradePartnersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TeamMembersTileTradePartnersQuery, TeamMembersTileTradePartnersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TeamMembersTileTradePartnersQuery, TeamMembersTileTradePartnersQueryVariables>(TeamMembersTileTradePartnersDocument, options);
        }
export type TeamMembersTileTradePartnersQueryHookResult = ReturnType<typeof useTeamMembersTileTradePartnersQuery>;
export type TeamMembersTileTradePartnersLazyQueryHookResult = ReturnType<typeof useTeamMembersTileTradePartnersLazyQuery>;
export type TeamMembersTileTradePartnersSuspenseQueryHookResult = ReturnType<typeof useTeamMembersTileTradePartnersSuspenseQuery>;
export type TeamMembersTileTradePartnersQueryResult = Apollo.QueryResult<TeamMembersTileTradePartnersQuery, TeamMembersTileTradePartnersQueryVariables>;